import { ACCOUNT_BAN_TYPES } from '~/constants';

export const isChatDenied = (...accounts: Array<{ bans: ACCOUNT_BAN_TYPES[] }>) => {
  return accounts.some((account) => account?.bans?.includes(ACCOUNT_BAN_TYPES.CHAT_DENIED));
};
